import React, { Component } from "react";
import { Table } from "antd";

interface Props {
  handleCancel?: any;
  data?: any;
  visible?: boolean;
  loading?: boolean;
  title?: string;
}
interface State {
  visible: boolean;
}
const columns = [
  {
    title: "STT",
    key: "key",
    render: (text, record, index) => index + 1,
    className: "text-center",
    width: "10%",
  },
  {
    title: "Tài liệu bán hàng",
    dataIndex: "doc_asset_name",
    key: "doc_asset_id",
  },
  {
    title: "Đơn vị",
    dataIndex: "doc_unit",
    className: "text-center",
    key: "doc_unit",
  },
  {
    title: "Số lượng",
    dataIndex: "doc_amount",
    className: "text-center",
    key: "doc_amount",
  },
];
export default class TokenList extends Component<Props, State> {
  componentDidMount() {}

  render() {
    return (
      <div>
        <Table
          className={"w-100 m-t-20 ant-table-bordered"}
          columns={columns}
          dataSource={this.props.data ? this.props.data : []}
          rowKey="id1"
        />
      </div>
    );
  }
}
